export default __webpack_public_path__ + "src/images/packages/eco-karoo-lodge/b11dff1684799f6018629cc1bd5d84ce-4.png";